export enum SocketEventAction {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  ERROR = 'ERROR',
}
